export const GIFT_ANONYMITY_PUBLIC = 0;
export const GIFT_ANONYMITY_RECIPIENT = 1;
export const GIFT_ANONYMITY_NOBODY = 2;

export const GIFT_SEND_RESULT_SENT = 'sent';
export const GIFT_SEND_RESULT_SAVED = 'saved';
export const GIFT_SEND_RESULT_INSUFFICIENT_AMOUNT = 'insufficientAmount';


// WEBPACK FOOTER //
// ./src/constants/virtualGifts.js